<template>
    <div v-if="menu.length > 0" class="sub-menu-bar">
        <div class="max-width-container">
            <nav class="sub-nav">
                <router-link
                    v-for="item in menu"
                    :key="item.path"
                    :to="item.path"
                    class="sub-nav-link"
                    active-class="active"
                    :class="{ active: $route.meta.menuPath === item.path }"
                >
                    {{ item.title }}
                </router-link>
            </nav>
        </div>
    </div>
</template>

<script>
export default {
    name: "SubMenu",
    props: {
        // Option 1: Pass a parent route name to auto-derive sibling/child sub-routes from the router config
        parentRouteName: {
            type: String,
            default: null,
        },
        // Option 2: Pass items explicitly if needed
        items: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            menu: [],
        };
    },
    mounted() {
        if (this.items.length > 0) {
            this.menu = this.items;
        } else if (this.parentRouteName) {
            const routes = this.$router.options.routes || [];
            const parentRoute = routes.find(
                (r) => r.name === this.parentRouteName
            );
            if (parentRoute) {
                const basePath = parentRoute.path;
                // Return all routes matching the prefix basePath (including the parent if it has a title)
                this.menu = routes
                    .filter((r) => r.path.startsWith(basePath) && r.title)
                    .map((r) => ({
                        path: r.path,
                        title: r.title,
                    }));
            }
        }
    },
};
</script>
